import {
  APIComponentAttributes,
  APIComponentType,
  APIFieldAttributes,
  APIFieldType,
} from '@ardoq/api-types';
import { toFieldTypeKey } from 'streams/fields/fields$';
import { GraphModelData } from './graphModelData';

export type ComponentTypeInfo = {
  componentType: APIComponentType | null;
  urlFields: APIFieldAttributes[];
};

export const getComponentTypeInfoFor = (
  component: APIComponentAttributes,
  { componentTypesByWorkspaceId, fieldsByComponentType }: GraphModelData
): ComponentTypeInfo => {
  const componentTypes = componentTypesByWorkspaceId[component.rootWorkspace];
  const fieldTypeKey = toFieldTypeKey(component.model, component.typeId);
  const fields = fieldsByComponentType.get(fieldTypeKey) ?? [];
  return {
    componentType:
      componentTypes?.find(({ id }) => id === component.typeId) ?? null,
    urlFields: fields.filter(field => field.type === APIFieldType.URL),
  };
};

export const createComponentTypeInfoCache = (
  graphModelData: GraphModelData
) => {
  const cache = new Map<string, ComponentTypeInfo>();
  return (component: APIComponentAttributes): ComponentTypeInfo => {
    const key = `${component.model}:${component.typeId}`;
    if (!cache.has(key)) {
      cache.set(key, getComponentTypeInfoFor(component, graphModelData));
    }
    return cache.get(key)!;
  };
};
